import { Icon } from "@iconify/react";
import React from "react";
import { useTranslation } from "react-i18next";

const ModernFooter: React.FC = () => {
  const { t } = useTranslation();

  return (
    <footer className="py-8 border-t bg-white" style={{ borderTopColor: '#e5e7eb' }}>
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="mb-4 md:mb-0">
            <p className="text-sm text-gray-500">
              {t("modern.footer.copyright", { year: new Date().getFullYear() })}
            </p>
          </div>

          <div className="flex flex-wrap gap-4 md:gap-6">
            <a
              href="https://www.apple.com/legal/internet-services/itunes/dev/stdeula/"
              className="text-sm text-gray-600 hover:text-black"
              target="_blank"
              rel="noopener noreferrer"
            >
              {t("modern.footer.termsConditions")}
            </a>
            <a
              href="https://youwo.ai/privacy-policy"
              className="text-sm text-gray-600 hover:text-black"
              target="_blank"
              rel="noopener noreferrer"
            >
              {t("modern.footer.privacyPolicy")}
            </a>
            <a
              href="https://discord.com/invite/N5NGdUxTJN"
              className="text-gray-600 hover:text-black"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Icon icon="logos:discord-icon" className="w-5 h-5" />
            </a>
            <a
              href="https://www.linkedin.com/company/youwoai/"
              className="text-gray-600 hover:text-black"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Icon icon="logos:linkedin-icon" className="w-5 h-5" />
            </a>
            <a
              href="https://www.instagram.com/youwo.ai/"
              className="text-gray-600 hover:text-black"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Icon icon="logos:instagram-icon" className="w-5 h-5" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default ModernFooter;
